import * as Scrivito from "scrivito";
import { colors } from "^/config/attributeConsts";
import defaultPageAttributes from "../_defaultPageAttributes";
import metadataAttributes from "../_metadataAttributes";

const Homepage = Scrivito.provideObjClass("Homepage", {
  attributes: {
    ...defaultPageAttributes,
    cookieConsentLink: "link",
    childOrder: "referencelist",
    footer: "widgetlist",
    dividerLogo: ["reference", { only: ["Image"] }],
    facebookAppId: "string",
    twitterSite: "string",
    googleAnalyticsTrackingId: "string",
    footerContent: "widgetlist",
    favLinks: "linklist",
    footerLinks: "linklist",
    footerSocialLinks: "linklist",
    searchPage: "reference",
    easyLanguagePage: "reference",
    signLanguagePage: "reference",
    llmsContent: "string",
    locals: "string",
    navigationType: ["enum", { values: ["two_lines", "one_line"] }],
    intranetLoginLink: "link",
    optionsPage: "reference",
    cookieBannerText: "html",
    additionalNavigationContent: "widgetlist",
    showAdditionalNavigationContent: ["enum", { values: ["yes", "no"] }],
    additionalNavigationContentTitle: "string",
    logo: ["reference", { only: "Image" }],
    backgroundColor: [
      "enum",
      {
        values: colors,
      },
    ],
    language: ["enum", { values: ["auto", "en", "de"] }],
    // Boolean defaults to true when never set by an editor.
    showStatusDot: "boolean",
    teaserText: "string",
    showAiChat: "boolean",
    ...metadataAttributes,
  },
  extractTextAttributes: ["body", "title", "segmentName"],
});

export default Homepage;
